/*
 * Hospitality & Trade landing page (MER-243 / MER-242).
 * Loaded only on the "hospitality" page template (snippets/rm-custom-hosp-head.liquid).
 *
 * 1. UTM passthrough: every quote CTA (a[data-rmh-cta]) already carries
 *    ?product=<key>&from=<section> from Liquid. Any utm_* params on this page's
 *    URL are appended so the Forge quote form can save the source.
 * 2. CTA-click event: published through Shopify's Customer Events API
 *    (Shopify.analytics.publish), the same channel the theme already uses for
 *    rm_measure_video_play. A custom pixel forwards it to GA4 / other tools.
 * 3. Mobile menu toggle for the page header (layout/theme.hospitality.liquid).
 */
(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var EVENT_NAME = 'rm_hosp_quote_cta_click';

  function readUtms() {
    var out = [];
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return out;
    }
    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) out.push([key, value.slice(0, 200)]);
    });
    return out;
  }

  function decorateCtas(utms) {
    if (!utms.length) return;
    var links = document.querySelectorAll('a[data-rmh-cta]');
    Array.prototype.forEach.call(links, function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        utms.forEach(function (pair) {
          if (!url.searchParams.has(pair[0])) url.searchParams.set(pair[0], pair[1]);
        });
        link.setAttribute('href', url.toString());
      } catch (e) {
        /* leave the link as rendered */
      }
    });
  }

  function trackClicks() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('a[data-rmh-cta]') : null;
      if (!link) return;
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var utms = {};
          readUtms().forEach(function (pair) { utms[pair[0]] = pair[1]; });
          Shopify.analytics.publish(EVENT_NAME, {
            product: link.getAttribute('data-rmh-product') || '',
            from: link.getAttribute('data-rmh-from') || '',
            href: link.href,
            page: window.location.pathname,
            utm: utms
          });
        }
      } catch (e) {
        /* analytics must never block navigation */
      }
    });
  }

  /* Mobile menu toggle (prototype #menuToggle): ☰ / ×, closes when a link is tapped. */
  function navToggle() {
    var toggle = document.querySelector('[data-rmh-nav-toggle]');
    var links = document.querySelector('[data-rmh-nav-links]');
    if (!toggle || !links || toggle.getAttribute('data-rmh-bound')) return;
    toggle.setAttribute('data-rmh-bound', '1');
    function set(open) {
      toggle.setAttribute('aria-expanded', String(open));
      links.classList.toggle('is-open', open);
      toggle.textContent = open ? '\u00d7' : '\u2630';
    }
    toggle.addEventListener('click', function () {
      set(toggle.getAttribute('aria-expanded') !== 'true');
    });
    Array.prototype.forEach.call(links.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () { set(false); });
    });
  }

  function init() {
    decorateCtas(readUtms());
    navToggle();
  }

  trackClicks();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when a section is added/re-rendered. */
  document.addEventListener('shopify:section:load', init);
})();
